import React from 'react';
import MaterialIconButton from '@material-ui/core/IconButton';

const IconButton = (props) => {
  const { type } = props;
  return <MaterialIconButton color={type} {...props} />;
};

export default IconButton;
